/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class CurativeActionService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'CurativeActionService\' loaded');
    }
}

export { CurativeActionService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/CurativeActionService.js